<button
  class="bg-primary relative flex h-full w-fit cursor-pointer items-center justify-center rounded-full p-1 focus:outline-0"
  (click)="triggerClicked.emit(); $event.stopPropagation()"
  #menuButton>
  @let controlValue = control().value;
  @if (!controlValue) {
    <span class="material-icons" [ngStyle]="{ color: 'white' }">add</span>
  } @else {
    <span class="block w-full overflow-hidden px-3 text-white">
      {{ optionLabelByKey()[controlValue] }}
    </span>
  }

  @if (isOpened()) {
    <div
      floatingElement
      [placement]="'bottom-end'"
      [isOpened]="isOpened()"
      [offsetConfig]="{ main: 10 }"
      [anchor]="menuButton"
      (outsideClick)="isOpened() && this.outsideClick.emit()"
      class="fixed z-[100] flex w-fit flex-col items-start rounded bg-white px-1 py-3 shadow-[0px_2px_4px_rgba(0,0,0,0.33)]">
      @if (header()) {
        <span class="mb-2 px-3 font-bold">{{ header() }}</span>
      }
      @for (option of optionLabelByKey() | keyvalue: germanSortOrder; track $index) {
        @let key = option.key;
        @let label = option.value;
        <button
          class="word-bre hover:bg-primary focus:bg-primary w-full cursor-pointer rounded px-3 text-left text-nowrap focus:outline-none"
          (click)="selectValue.emit(key); $event.stopPropagation()">
          {{ label }} ({{ label[0] }})
        </button>
      }
    </div>
  }
</button>
